<template>
  <div id="zoom">
  </div>
</template>

<script setup>
import {ref, inject, onMounted, watch} from 'vue';
import {ZoomSlider} from 'ol/control';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const zoomSlider = ref(null);
const mapRef = inject('instanceMapRef');
// #endregion

// #region Functions
function createZoom(map) {
  zoomSlider.value = new ZoomSlider();
}
function removeZoom(map) {
  if (!!zoomSlider?.value) {
    map.removeControl(zoomSlider.value);
  }
}
function addZoomSlider(map) {
  removeZoom(map);
  createZoom(map);
  if (!!zoomSlider?.value) {
    map.addControl(zoomSlider.value);
  }
}
// #endregion

// #region Effects, Hooks
watch((mapRef), (newMapRef) => {
  if (!!newMapRef) {
    addZoomSlider(newMapRef);
  }
});
onMounted(async () => {
  if (!!mapRef?.value) {
    addZoomSlider(mapRef.value);
  }
});
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>

</style>
